import { render } from "./TournamentArenaList.vue?vue&type=template&id=d64dd76a&scoped=true"
import script from "./TournamentArenaList.vue?vue&type=script&lang=js"
export * from "./TournamentArenaList.vue?vue&type=script&lang=js"

import "./TournamentArenaList.vue?vue&type=style&index=0&id=d64dd76a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64dd76a"]])

export default __exports__